import { type ReactElement } from 'react'
import * as S from './about.styled'
import { AboutCard } from '../about-card/about-card'
import { cards } from './cards'
import { Swiper } from '../swiper/swiper'
import { LinkButton } from '../button/link-button'

export function About (): ReactElement {
  return <S.Container>
    <S.Content>
      <h1>Tudo o que você sempre sonhou agora você pode ter.</h1>
      <Swiper className="swiper" offset={24}>
        {cards.map((card, i) => <AboutCard key={i} {...card} />)}
      </Swiper>
      <LinkButton to="https://idpv.cartaodetodos.com.br/dados-pessoais/?from_lead=1&idpv=593fe813-3579-442f-b0c2-17a883e92e24">Quero meu cartão</LinkButton>
    </S.Content>
  </S.Container>
}
